import React from 'react'
import { Alertbox } from '@olxbr/ds-web'
import { Lock } from '@olxbr/ds-icons'
import styled from 'styled-components'

export const TipsBox = () => {
  const Container = styled.div`
    margin-top: var(--spacing-4);
  `

  return (
    <Container>
      <Alertbox icon={<Lock color="var(--color-neutral-110)" />} flex="1" variant="neutral">
        <span className="typo-body-medium font-semibold">
          É rapidinho {''}
          <span className="typo-body-medium inline">
            e ajuda a garantir que só você tenha acesso à sua conta!
          </span>
        </span>
      </Alertbox>
    </Container>
  )
}
